import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Info, Mail } from 'lucide-react';

const OverOns = () => {
  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-block bg-[#FDB913] rounded-full p-4 mb-4">
            <Info size={40} className="text-[#1a2332]" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-2">Over Ons</h1>
          <p className="text-muted-foreground">Sportpooltjes - Bets for fun</p>
        </div>

        <Card className="border-2 border-[#FDB913]">
          <CardContent className="pt-6 prose prose-lg max-w-none">
            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes is een platform waar sport, plezier, en geluk samen komen. Op dit platform vind je diverse pooltjes die het kijken naar een sport veel leuker maken. Je zal vroeger vast wel eens een toto ingevuld hebben bij de plaatselijke boekenhandel of sigarenboer of misschien wel op het werk een keer hebben meegedaan aan een weddenschap voor een WK of EK. Op die manier werd de wedstrijd of race veel leuker en zit je op het puntje van je stoel met de voorspelling die je gedaan naast je. Via Sportpooltjes kan je pooltjes vinden voor diverse sporten. Niet alleen het WK en EK voetbal, maar ook Formule 1, MotoGP, voetbalcompetities, wielrennen, tennis, en nog veel meer.
            </p>

            <p className="text-muted-foreground leading-relaxed mb-6">
              Voetbal is de nummer 1 sport waar op gewed wordt, maar ook op diverse andere sporten wordt gegokt. Je kan via de diverse bookmakers (online) een gokje wagen, maar ook bij diverse sigarenboeren en boekenhandels kan je door een formulier in te vullen een voorspelling doen bij een aantal bookmakers. Doordat er een zeer gevarieerd aanbod is, van wedstrijden uit de Eredivisie tot aan wedstrijden uit de Vietnamese competitie. Wedstrijden uit de Europese competities, de Champions League, de Europa League worden vaak in grote getalen aangeboden.
            </p>

            <div className="bg-[#FDB913]/10 border-l-4 border-[#FDB913] p-4 my-6">
              <p className="text-foreground font-medium">
                Sportpooltjes biedt enkel en alleen een poolsysteem aan. Inzetten van hoge waarden kan niet op dit platform. Sportpooltjes is er voor vrienden en collega's onder elkaar die voor de gezelligheid een weddenschap willen maken voor wedstrijden of races.
              </p>
            </div>

            <p className="text-muted-foreground leading-relaxed mb-6">
              Op f1.sportpooltjes.nl kan je als medewerker waar SPV The Fun Club onderdeel van is meedoen met een Formule 1 pool. Voor dat dit platform opgericht was hadden we een Formule 1 pool in het programma Microsoft Excel. Aangezien dit behoorlijk omslachtig was qua invullen moesten we wat anders bedenken. Met dit huidige platform denken wij dat sport en spanning weer terug is aan de stamtafel in de kantine. Met deelname aan deze Formule 1 pool ga je 100% anders naar een Formule 1 race kijken en heb je gegarandeerd plezier en dat samen met jouw collegae.
            </p>

            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes, onderdeel van personeelsvereniging SPV The Fun Club, wordt o.a. aangeboden voor personeelsleden waar ook SPV The Fun Club onderdeel van is. Sportpooltjes en SPV The Fun Club hebben geen winstoogmerk en zullen alle ingelegde gelden minus administratiekosten uitkeren aan de ingeschreven deelnemers.
            </p>

            <div className="bg-[#FDB913]/30 dark:bg-[#1a2332] p-6 rounded-lg my-6 text-center border-2 border-[#FDB913]">
              <p className="text-muted-foreground dark:text-gray-300 mb-2">De slogan luidt ook niet voor niets...</p>
              <p className="text-3xl font-bold text-[#FDB913]">
                BETS FOR FUN
              </p>
            </div>

            <p className="text-muted-foreground leading-relaxed mb-6">
              Deelnemers die ingeschreven staan maar geen medewerker zijn waar SPV The Fun Club onderdeel van is, kunnen wel deelnemen aan de pool, dingen mee voor de prijzen volgens de payoutstructure maar kunnen geen aanspraak maken op tickets voor eventuele races die de werkgever, waar SPV The Fun Club aan gelieerd is, beschikbaar stelt. Deze eventuele beschikbare tickets zullen worden verloot onder de deelnemers die werknemer zijn van de werkgever waar SPV The Fun Club aan gelieerd is.
            </p>

            <div className="bg-red-100 dark:bg-red-900/30 border-l-4 border-red-500 p-4 my-6">
              <p className="text-red-700 dark:text-red-400 font-semibold">
                Deelnemers die nog geen 18 jaar oud zijn worden uitgesloten van deelname.
              </p>
            </div>

            {/* Contact */}
            <div className="mt-8 pt-6 border-t border-border">
              <h3 className="text-lg font-semibold text-foreground mb-4">Contact</h3>
              <a 
                href="mailto:info@sportpooltjes.nl" 
                className="inline-flex items-center text-gray-700 dark:text-[#FDB913] hover:underline"
              >
                <Mail className="mr-2 text-[#FDB913]" size={18} />
                info@sportpooltjes.nl
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OverOns;
